import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import MobileSlotForm from './MobileSlotForm'

export default function MobileCreateSlotPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <>
      <PublicSiderXS />
      <MobileSlotForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
    </>
  )
}
